import { ActivityPartAxis } from '@/api/models/aggregate'
import { useAppSelector } from '@/store/hooks'

export const useActiveActivityPartAxis = (): ActivityPartAxis | null =>
  useAppSelector((store) => store.aggregate.activeActivityPartAxis)
